import React, { useState, useEffect } from 'react';
import './TasksPage.css';
import Header from '../components/Header';

function TasksPage() {
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => { document.title = 'PEC - Tareas'; }, []);

  // Mock data for tasks - you can replace with real data
  const tasks = [
    {
      id: 1,
      title: 'Finalizar propuesta comercial Q1 2024',
      description: 'Completar la presentación para el cliente VIP incluyendo análisis de ROI y cronograma detallado',
      dueDate: '2024-01-15',
      priority: 'high',
      status: 'in-progress',
      project: 'Ventas',
      assignee: 'María González',
      progress: 75,
      tags: ['urgente', 'cliente-vip', 'revenue'],
      icon: '💼',
      color: 'blue'
    },
    {
      id: 2,
      title: 'Implementar autenticación OAuth',
      description: 'Integrar sistema de login con Google y GitHub para mejorar la experiencia del usuario',
      dueDate: '2024-01-18',
      priority: 'high',
      status: 'todo',
      project: 'Desarrollo',
      assignee: 'Carlos Mendoza',
      progress: 0,
      tags: ['backend', 'seguridad', 'auth'],
      icon: '🔐',
      color: 'purple'
    },
    {
      id: 3,
      title: 'Revisar contratos legales',
      description: 'Análisis legal de 3 contratos de proveedores y validación de cláusulas de confidencialidad',
      dueDate: '2024-01-12',
      priority: 'medium',
      status: 'review',
      project: 'Legal',
      assignee: 'Ana Rodríguez',
      progress: 90,
      tags: ['contratos', 'legal', 'proveedores'],
      icon: '⚖️',
      color: 'orange'
    },
    {
      id: 4,
      title: 'Optimización de base de datos',
      description: 'Mejorar performance de consultas principales y implementar índices optimizados',
      dueDate: '2024-01-20',
      priority: 'medium',
      status: 'in-progress',
      project: 'Desarrollo',
      assignee: 'Luis Torres',
      progress: 45,
      tags: ['database', 'performance', 'backend'],
      icon: '🗄️',
      color: 'green'
    },
    {
      id: 5,
      title: 'Campaña de marketing digital',
      description: 'Diseñar y lanzar campaña en redes sociales para el nuevo producto',
      dueDate: '2024-01-25',
      priority: 'low',
      status: 'todo',
      project: 'Marketing',
      assignee: 'Sofia López',
      progress: 15,
      tags: ['social-media', 'branding', 'digital'],
      icon: '📱',
      color: 'pink'
    },
    {
      id: 6,
      title: 'Reunión trimestral con equipo',
      description: 'Planificar agenda y preparar reportes de resultados para la reunión Q1',
      dueDate: '2024-01-14',
      priority: 'medium',
      status: 'completed',
      project: 'Gestión',
      assignee: 'Roberto Silva',
      progress: 100,
      tags: ['meeting', 'quarterly', 'reports'],
      icon: '👥',
      color: 'indigo'
    }
  ];

  const taskStats = {
    total: tasks.length,
    completed: tasks.filter(task => task.status === 'completed').length,
    inProgress: tasks.filter(task => task.status === 'in-progress').length,
    overdue: tasks.filter(task => new Date(task.dueDate) < new Date() && task.status !== 'completed').length,
    highPriority: tasks.filter(task => task.priority === 'high').length
  };

  // Filter tasks based on search term
  const filteredTasks = tasks.filter(task =>
    task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    task.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    task.project.toLowerCase().includes(searchTerm.toLowerCase()) ||
    task.assignee.toLowerCase().includes(searchTerm.toLowerCase()) ||
    task.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleTaskAction = (taskId, action) => {
    console.log(`${action} task:`, taskId);
    // Implement task action functionality
  };

  const handleCreateTask = () => {
    console.log('Creating new task');
    // Implement create task functionality
  };

  

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'red';
      case 'medium': return 'orange';
      case 'low': return 'blue';
      default: return 'gray';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = date - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return 'Vencida';
    if (diffDays === 0) return 'Hoy';
    if (diffDays === 1) return 'Mañana';
    if (diffDays <= 7) return `En ${diffDays} días`;
    return date.toLocaleDateString();
  };

  const isOverdue = (dateString, status) => {
    return new Date(dateString) < new Date() && status !== 'completed';
  };

  return (
    <div className="tasks-page">
      <Header 
        currentPage="tasks" 
        showSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        showAddButton 
        onAddNew={handleCreateTask}
      />

      <div className="tasks-content">
        {/* Task Stats */}
        <div className="task-stats">
          <div className="stat-card total">
            <div className="stat-icon">📋</div>
            <div className="stat-content">
              <h3>{taskStats.total}</h3>
              <p>Total Tareas</p>
            </div>
          </div>
          <div className="stat-card completed">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <h3>{taskStats.completed}</h3>
              <p>Completadas</p>
            </div>
          </div>
          <div className="stat-card in-progress">
            <div className="stat-icon">🔄</div>
            <div className="stat-content">
              <h3>{taskStats.inProgress}</h3>
              <p>En Progreso</p>
            </div>
          </div>
          <div className="stat-card overdue">
            <div className="stat-icon">⚠️</div>
            <div className="stat-content">
              <h3>{taskStats.overdue}</h3>
              <p>Vencidas</p>
            </div>
          </div>
        </div>

        {/* Tasks List */}
        <div className="tasks-section">
          <div className="section-header">
            <h2>Lista de Tareas ({filteredTasks.length})</h2>
            <div className="section-actions">
              <button className="btn-secondary">Filtros</button>
              <button className="btn-secondary">Ordenar</button>
              <button className="btn-secondary">Vista</button>
            </div>
          </div>

          <div className="tasks-list">
            {filteredTasks.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">📝</div>
                <h3>No se encontraron tareas</h3>
                <p>Intenta ajustar los términos de búsqueda o crear una nueva tarea</p>
              </div>
            ) : (
              filteredTasks.map((task) => (
                <div key={task.id} className={`task-card ${task.status} ${getPriorityColor(task.priority)} ${isOverdue(task.dueDate, task.status) ? 'overdue' : ''}`}>
                  <div className="task-header">
                    <div className="task-icon">
                      <span>{task.icon}</span>
                    </div>
                    <div className="task-meta">
                      <div className="task-title-row">
                        <h4 className="task-title">{task.title}</h4>
                        <div className={`priority-badge ${task.priority}`}>
                          {task.priority.toUpperCase()}
                        </div>
                      </div>
                      <div className="task-info">
                        <span className="task-project">{task.project}</span>
                        <span className="task-assignee">👤 {task.assignee}</span>
                        <span className={`task-due-date ${isOverdue(task.dueDate, task.status) ? 'overdue' : ''}`}>
                          📅 {formatDate(task.dueDate)}
                        </span>
                      </div>
                    </div>
                    <div className={`status-badge ${task.status}`}>
                      {task.status.replace('-', ' ').toUpperCase()}
                    </div>
                  </div>
                  
                  <div className="task-content">
                    <p className="task-description">{task.description}</p>
                    
                    <div className="task-progress">
                      <div className="progress-info">
                        <span>Progreso: {task.progress}%</span>
                      </div>
                      <div className="progress-bar">
                        <div 
                          className="progress-fill"
                          style={{ width: `${task.progress}%` }}
                        ></div>
                      </div>
                    </div>

                    <div className="task-tags">
                      {task.tags.map((tag, index) => (
                        <span key={index} className="task-tag">
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="task-actions">
                    <button 
                      className="btn-action primary"
                      onClick={() => handleTaskAction(task.id, 'view')}
                    >
                      Ver Detalles
                    </button>
                    <button 
                      className="btn-action secondary"
                      onClick={() => handleTaskAction(task.id, 'edit')}
                    >
                      Editar
                    </button>
                    {task.status !== 'completed' && (
                      <button 
                        className="btn-action success"
                        onClick={() => handleTaskAction(task.id, 'complete')}
                      >
                        Completar
                      </button>
                    )}
                    <button 
                      className="btn-action danger"
                      onClick={() => handleTaskAction(task.id, 'delete')}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions-section">
          <h2>Gestión Rápida</h2>
          <div className="quick-actions-grid">
            <div className="quick-action-card">
              <div className="action-icon">📊</div>
              <h3>Dashboard</h3>
              <p>Vista general de tareas y progreso</p>
              <button className="btn-primary">Ver Dashboard</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">🗂️</div>
              <h3>Proyectos</h3>
              <p>Organizar tareas por proyectos</p>
              <button className="btn-primary">Ver Proyectos</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">📅</div>
              <h3>Calendario</h3>
              <p>Vista de tareas por fechas</p>
              <button className="btn-primary">Ver Calendario</button>
            </div>
            <div className="quick-action-card">
              <div className="action-icon">⚡</div>
              <h3>Automatización</h3>
              <p>Crear reglas y flujos automáticos</p>
              <button className="btn-primary">Configurar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TasksPage; 